import { gql } from '@apollo/client';

export const CREATE_CHAT_GROUP = gql`
  mutation CreateChatGroup($input: CreateChatGroupInput!) {
    createChatGroup(input: $input) {
      id
      name
      description
      avatar
      isPrivate
      createdAt
      members {
        id
        userId
        # user {
        #   id
        #   name
        #   avatar {
        #     thumb
        #   }
        # }
        role
        isMuted
        lastReadAt
      }
    }
  }
`;

export const JOIN_CHAT_GROUP = gql`
  mutation AddChatGroupMembers($input: AddChatGroupMembersInput!) {
    addChatGroupMembers(input: $input) {
      id
      role
      isMuted
      lastReadAt
      user {
        id
        name
        avatar {
          thumb
        }
      }
    }
  }
`;

export const LEAVE_CHAT_GROUP = gql`
  mutation LeaveChatGroup($chatGroupId: ID!) {
    leaveChatGroup(chatGroupId: $chatGroupId)
  }
`;



export const CREATE_CONVERSATION = gql`
  mutation ($input: ConversationInput!) {
    createConversation(input: $input) {
      id
      user_id
      friend_id
      user {
        id
        email
        name
        avatar {
          name
          path
          placeholder
          thumb
        }
      }
      friend {
        id
        email
        name
        avatar {
          name
          path
          placeholder
          thumb
        }
      }
    }
  }
`;

// ===========================================
// EVENT GROUP CHAT MUTATIONS
// ===========================================

export const SEND_EVENT_MESSAGE = gql`
  mutation ($input: SendEventMessageInput!) {
    sendEventMessage(input: $input) {
      id
      message
      type
      metadata
      createdAt
      sender {
        id
        name
        avatar {
          thumb
        }
      }
    }
  }
`;

export const JOIN_EVENT_CHAT = gql`
  mutation ($input: JoinEventChatInput!) {
    joinEventChat(input: $input) {
      id
      role
      isMuted
      lastReadAt
      user {
        id
        name
        avatar {
          thumb
        }
      }
    }
  }
`;

export const LEAVE_EVENT_CHAT = gql`
  mutation ($eventChatId: ID!) {
    leaveEventChat(eventChatId: $eventChatId)
  }
`;

export const CREATE_EVENT_CHAT = gql`
  mutation ($input: CreateEventChatInput!) {
    createEventChat(input: $input) {
      id
      event_id
      created_by
      settings {
        allow_all_applicants
        require_approval
        auto_add_accepted_applicants
        moderator_only_announcements
      }
      event {
        id
        title
        slug
      }
      created_at
    }
  }
`;

export const UPDATE_EVENT_CHAT_SETTINGS = gql`
  mutation ($input: UpdateEventChatSettingsInput!) {
    updateEventChatSettings(input: $input) {
      id
      settings {
        allow_all_applicants
        require_approval
        auto_add_accepted_applicants
        moderator_only_announcements
        max_participants
        chat_enabled
      }
      updated_at
    }
  }
`;

export const ADD_EVENT_CHAT_PARTICIPANT = gql`
  mutation ($input: AddEventChatParticipantInput!) {
    addEventChatParticipant(input: $input) {
      id
      user_id
      event_id
      role
      added_by
      joined_at
      user {
        id
        name
        email
        avatar {
          thumb
        }
      }
    }
  }
`;

export const REMOVE_EVENT_CHAT_PARTICIPANT = gql`
  mutation ($input: RemoveEventChatParticipantInput!) {
    removeEventChatParticipant(input: $input) {
      success
      message
    }
  }
`;

export const UPDATE_EVENT_CHAT_PARTICIPANT_ROLE = gql`
  mutation ($input: UpdateEventChatParticipantRoleInput!) {
    updateEventChatParticipantRole(input: $input) {
      id
      user_id
      event_id
      role
      updated_at
      user {
        id
        name
      }
    }
  }
`;

export const DELETE_EVENT_MESSAGE = gql`
  mutation ($input: DeleteEventMessageInput!) {
    deleteEventMessage(input: $input) {
      success
      message
    }
  }
`;

export const PIN_EVENT_MESSAGE = gql`
  mutation ($input: PinEventMessageInput!) {
    pinEventMessage(input: $input) {
      id
      message_id
      pinned_by
      pinned_at
      message {
        id
        message
        sender {
          id
          name
        }
        created_at
      }
    }
  }
`;

export const UNPIN_EVENT_MESSAGE = gql`
  mutation ($input: UnpinEventMessageInput!) {
    unpinEventMessage(input: $input) {
      success
      message
    }
  }
`;

// ===========================================
// MESSAGE STATUS MUTATIONS
// ===========================================

export const MARK_CONVERSATION_READ = gql`
  mutation ($input: MarkConversationReadInput!) {
    markConversationRead(input: $input) {
      success
      unread_count
    }
  }
`;

export const MARK_EVENT_CHAT_READ = gql`
  mutation ($eventChatId: ID!) {
    markEventChatAsRead(eventChatId: $eventChatId)
  }
`;

export const UPDATE_TYPING_STATUS = gql`
  mutation ($input: TypingStatusInput!) {
    updateTypingStatus(input: $input) {
      success
    }
  }
`;

export const UPDATE_USER_PRESENCE = gql`
  mutation ($input: UserPresenceInput!) {
    updateUserPresence(input: $input) {
      success
      status
      last_seen_at
    }
  }
`;

export const UPDATE_GROUP_CHAT_MEMBER = gql`
  mutation UpdateGroupChatMember($input: UpdateGroupChatMemberInput!) {
    updateGroupChatMember(input: $input) {
      id
      role
      isMuted
      lastReadAt
      user {
        id
        name
        avatar {
          thumb
        }
      }
    }
  }
`;


export const MARK_GROUP_CHAT_AS_READ = gql`
  mutation MarkGroupChatAsRead($groupChatId: ID!) {
    markGroupChatAsRead(groupChatId: $groupChatId)
  }
`;